import script from "./Product.vue?vue&type=script&setup=true&lang=js"
export * from "./Product.vue?vue&type=script&setup=true&lang=js"

import "./Product.vue?vue&type=style&index=0&id=738a7497&scoped=true&lang=css"
import "./Product.vue?vue&type=style&index=1&id=738a7497&scoped=true&lang=css"

import exportComponent from "/Users/ezink/Downloads/海/vue-antd-tool-web 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-738a7497"]])

export default __exports__